import { Avatar, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

interface empprofileType {
  avatar: any;
  name: string;
}
const EmpProfile: React.FC<empprofileType> = ({ avatar, name }) => {
  return (
    <Grid container spacing={1}>
      <Grid item>
        <Avatar
          src={avatar}
          style={{ width: 32, height: 32, marginRight: 5 }}
        />
      </Grid>
      <Grid item style={{ marginTop: "0.4em" }}>
        <Typography
          style={{
            marginRight: 6,

            fontSize: "14px",
            fontWeight: "bold",
          }}
        >
          {name}
        </Typography>
      </Grid>
    </Grid>
  );
};
export default EmpProfile;
